(() => {
  if (window.GloCart) return;
  const root = document.querySelector('glo-mini-cart');
  if (!root) return;
  const messages = JSON.parse(root.querySelector('[data-glo-messages]').textContent);
  const cartPath = root.dataset.cartUrl;
  const route = endpoint => root.dataset.root + 'cart' + endpoint;
  const drawer = root.querySelector('dialog');
  const toast = root.querySelector('.glo-cart-toast');
  const state = {cart:null, queue:Promise.resolve(), noteDraft:null, busy:false, undo:null, passCheckout:false};
  const message = key => messages[key] || key;
  const addedLabel = count => message('in_cart').replace('[count]',count) + ' · ' + message('view_cart');
  const escape = value => CSS.escape(String(value));
  const sections = () => [root.dataset.section, ...Array.from(document.querySelectorAll('glo-main-cart[data-section],glo-cart-recommendations[data-section]'), el => el.dataset.section)];
  const notify = (text, undo = false) => {
    (drawer.open ? drawer : root).append(toast);
    toast.querySelector('[data-glo-toast-message]').textContent = text;
    toast.querySelector('[data-glo-undo]').hidden = !undo;
    toast.hidden = false;
    clearTimeout(state.toastTimer);
    state.toastTimer = setTimeout(() => { toast.hidden = true; }, undo ? 10000 : 5500);
  };
  const getCart = async () => {
    const response = await fetch(route('.js'), {headers:{Accept:'application/json'}, cache:'no-store'});
    if (!response.ok) throw new Error(message('error'));
    return response.json();
  };
  const updateCounts = cart => {
    state.cart = cart;
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = cart.item_count;
      el.closest('.cart-count-bubble')?.classList.toggle('is-empty', cart.item_count === 0);
    });
    const countLabel = cart.item_count === 1 ? message('item') : message('items');
    document.querySelectorAll('[data-glo-count-label]').forEach(el => { el.textContent = countLabel; });
    document.querySelectorAll('.cart-count-bubble .visually-hidden').forEach(el => { el.textContent = cart.item_count + ' ' + countLabel; });
    document.querySelectorAll('[data-glo-added-state]').forEach(el => {
      const count = cart.items.filter(item => String(item.variant_id) === el.dataset.gloAddedState).reduce((total,item) => total + item.quantity,0);
      el.textContent = addedLabel(count);
      el.hidden = count === 0;
    });
    document.dispatchEvent(new CustomEvent('glo:cart-updated',{detail:{cart}}));
  };
  const captureFocus = () => {
    const active = document.activeElement;
    const line = active?.closest('[data-glo-variant]');
    return {element:active, id:active?.id, variant:line?.dataset.gloVariant, selector:active?.matches('[data-glo-quantity]') ? '[data-glo-quantity]' : active?.matches('[data-glo-step]') ? '[data-glo-step="' + active.dataset.gloStep + '"]' : null, mini:!!active?.closest('dialog')};
  };
  const render = (html, cart) => {
    const focus = captureFocus();
    const note = document.querySelector('#GloCartNote');
    const noteValue = state.noteDraft !== null ? state.noteDraft : note?.value;
    const code = document.querySelector('#GloCartDiscount');
    const codeValue = code?.value;
    const status = document.querySelector('[data-glo-discount-status]')?.textContent;
    const scrolls = Array.from(document.querySelectorAll('[data-glo-slider]'), el => [el.id,el.scrollLeft]);
    Object.entries(html || {}).forEach(([id,markup]) => {
      if (!markup) return;
      const doc = new DOMParser().parseFromString(markup,'text/html');
      if (id === root.dataset.section) {
        const content = doc.querySelector('[data-glo-mini-content]');
        if (content) root.querySelector('[data-glo-mini-content]').replaceChildren(...content.childNodes);
      } else {
        const current = document.querySelector('[data-section="' + escape(id) + '"]');
        const next = doc.querySelector('[data-section="' + escape(id) + '"]');
        if (current && next) current.replaceWith(next);
      }
    });
    const newNote = document.querySelector('#GloCartNote');
    if (newNote && noteValue !== undefined) newNote.value = noteValue;
    const newCode = document.querySelector('#GloCartDiscount');
    if (newCode && codeValue !== undefined) newCode.value = codeValue;
    const newStatus = document.querySelector('[data-glo-discount-status]');
    if (newStatus && status) newStatus.textContent = status;
    scrolls.forEach(([id,left]) => { const el = document.getElementById(id); if (el) el.scrollLeft = left; });
    updateCounts(cart);
    if (focus.element && !focus.element.isConnected) {
      const scope = focus.mini ? drawer : document.querySelector('glo-main-cart');
      const nextFocus = focus.id ? document.getElementById(focus.id) : focus.variant && focus.selector ? scope?.querySelector('[data-glo-variant="' + escape(focus.variant) + '"] ' + focus.selector) : null;
      nextFocus?.focus({preventScroll:true});
    }
  };
  const refresh = async cart => {
    const url = new URL(cartPath,location.origin);
    url.searchParams.set('sections',sections().join(','));
    const response = await fetch(url,{cache:'no-store'});
    if (!response.ok) throw new Error(message('error'));
    render(await response.json(),cart || await getCart());
  };
  const mutate = async (endpoint,payload) => {
    const ids = sections();
    const options = {method:'POST',headers:{Accept:'application/json'}};
    if (payload instanceof FormData) {
      payload.set('sections',ids.join(',')); payload.set('sections_url',cartPath);
      payload.delete('return_to');
      options.body = payload;
    } else {
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify({...payload,sections:ids,sections_url:cartPath});
    }
    const response = await fetch(route('/' + endpoint + '.js'),options);
    const result = await response.json();
    if (!response.ok || result.status >= 400) throw new Error(typeof result.description === 'string' ? result.description : typeof result.message === 'string' ? result.message : message('error'));
    const cart = endpoint === 'add' ? await getCart() : result;
    if (!result.sections || ids.some(id => !result.sections[id])) await refresh(cart);
    else render(result.sections,cart);
    return cart;
  };
  const enqueue = task => {
    const work = state.queue.catch(() => {}).then(async () => {
      state.busy = true;
      try { return await task(); }
      finally { state.busy = false; }
    });
    state.queue = work;
    work.catch(() => {});
    return work;
  };
  const saveNote = async (announce = false) => {
    const input = document.querySelector('#GloCartNote');
    if (!input) return;
    const value = state.noteDraft !== null ? state.noteDraft : input.value;
    const response = await fetch(route('/update.js'),{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({note:value})});
    if (!response.ok) throw new Error(message('error'));
    const cart = await response.json();
    if (state.noteDraft === value) state.noteDraft = null;
    if (state.cart) state.cart.note = cart.note;
    const status = document.querySelector('[data-glo-note-status]');
    if (status) status.textContent = message('saved');
    if (announce) notify(message('saved'));
  };
  const applyDiscount = async () => {
    const input = document.querySelector('#GloCartDiscount');
    const value = input?.value.trim();
    const status = document.querySelector('[data-glo-discount-status]');
    if (!value) { if (status) status.textContent = message('discount_empty'); return; }
    await saveNote();
    const cart = await mutate('update',{discount:value});
    const code = cart.discount_codes?.find(entry => entry.code?.toLowerCase() === value.toLowerCase());
    const allocations = [...(cart.cart_level_discount_applications || []),...cart.items.flatMap(item => (item.line_level_discount_allocations || []).map(entry => entry.discount_application))];
    const applied = code?.applicable === true || allocations.some(entry => entry.title?.toLowerCase() === value.toLowerCase());
    const text = message(applied ? 'discount_applied' : code?.applicable === false ? 'discount_invalid' : 'discount_checkout');
    const current = document.querySelector('[data-glo-discount-status]');
    if (current) current.textContent = text;
  };
  const close = () => { if (drawer.open) drawer.close(); };
  drawer.addEventListener('close',() => { document.body.classList.remove('glo-mini-open'); root.append(toast); state.opener?.focus({preventScroll:true}); });
  drawer.addEventListener('click',event => { if (event.target === drawer) { const box = drawer.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) close(); } });
  const open = button => {
    state.opener = button;
    if (!drawer.open) drawer.showModal();
    document.body.classList.add('glo-mini-open');
    enqueue(async () => refresh(await getCart())).catch(error => notify(error.message));
  };
  const add = (form,button) => {
    if (!form || form.dataset.gloAdding === 'true' || button?.disabled || !form.reportValidity()) return;
    const data = new FormData(form);
    const id = data.get('id');
    if (!id && !Array.from(data.keys()).some(key => key.startsWith('items['))) return;
    if (!data.has('quantity')) data.set('quantity','1');
    const original = button?.innerHTML;
    form.dataset.gloAdding = 'true';
    if (button) { button.disabled = true; button.setAttribute('aria-busy','true'); button.textContent = message('adding'); }
    enqueue(async () => {
      const cart = await mutate('add',data);
      const count = cart.items.filter(item => String(item.variant_id) === String(id)).reduce((n,item) => n + item.quantity,0);
      const text = message('in_cart').replace('[count]',count);
      notify(message('added') + (count ? ' · ' + text : ''));
      if (button?.isConnected && count) {
        let feedback = form.querySelector('[data-glo-added-state]');
        if (!feedback) { feedback = document.createElement('button'); feedback.type = 'button'; feedback.className = 'glo-added-state'; feedback.setAttribute('data-glo-open',''); feedback.setAttribute('aria-haspopup','dialog'); feedback.setAttribute('aria-controls','GloMiniCartDialog'); button.insertAdjacentElement('afterend',feedback); }
        feedback.dataset.gloAddedState = id; feedback.textContent = addedLabel(count); feedback.hidden = false;
      }
    }).catch(error => notify(error.message)).finally(() => {
      delete form.dataset.gloAdding;
      if (button) { button.disabled = false; button.removeAttribute('aria-busy'); button.innerHTML = original; button.classList.remove('is-loading','loading'); }
    });
  };
  const changeQuantity = (line,quantity,removed = false) => {
    if (!line || state.busy || line.hasAttribute('data-glo-busy')) return;
    line.setAttribute('data-glo-busy','');
    const key = line.dataset.gloLineKey;
    enqueue(async () => {
      const cart = state.cart || await getCart();
      const item = cart.items.find(item => item.key === key);
      if (!item) { await refresh(cart); return; }
      await mutate('change',{id:key,quantity});
      if (removed || quantity === 0) {
        state.undo = {id:item.variant_id,quantity:item.quantity,properties:item.properties || {}};
        if (item.selling_plan_allocation?.selling_plan?.id) state.undo.selling_plan = item.selling_plan_allocation.selling_plan.id;
        notify(message('removed'),true);
      }
    }).catch(async error => { notify(error.message); try { await refresh(await getCart()); } catch {} }).finally(() => line.removeAttribute('data-glo-busy'));
  };
  document.addEventListener('click',event => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const openButton = target.closest('[data-glo-open]');
    if (openButton) { event.preventDefault(); event.stopImmediatePropagation(); open(openButton); return; }
    const closeButton = target.closest('[data-glo-close]');
    if (closeButton) { event.preventDefault(); close(); return; }
    if (target.closest('[data-glo-dismiss]')) { toast.hidden = true; return; }
    if (target.closest('[data-glo-undo]')) {
      const item = state.undo;
      if (!item) return;
      state.undo = null; toast.hidden = true;
      enqueue(() => mutate('add',{items:[item]})).catch(error => { state.undo = item; notify(error.message,true); }); return;
    }
    const sliderButton = target.closest('[data-glo-slide]');
    if (sliderButton) { document.getElementById(sliderButton.getAttribute('aria-controls'))?.scrollBy({left:Number(sliderButton.dataset.gloSlide) * 310,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth'}); return; }
    const control = target.closest('[data-glo-step],[data-glo-remove]');
    if (control) {
      event.preventDefault(); event.stopImmediatePropagation();
      const line = control.closest('[data-glo-line-key]');
      const input = line?.querySelector('[data-glo-quantity]');
      if (!input) return;
      let quantity = control.hasAttribute('data-glo-remove') ? 0 : Number(input.value) + Number(control.dataset.gloStep) * (Number(input.step) || 1);
      const minimum = Number(input.dataset.minimum) || 1;
      if (quantity > 0 && quantity < minimum) quantity = control.dataset.gloStep === '1' ? minimum : 0;
      if (quantity < 0 || (input.max && quantity > Number(input.max))) return;
      changeQuantity(line,quantity,control.hasAttribute('data-glo-remove')); return;
    }
    const noteButton = target.closest('[data-glo-save-note]');
    if (noteButton) { event.preventDefault(); event.stopImmediatePropagation(); enqueue(() => saveNote(true)).catch(error => notify(error.message)); return; }
    if (target.closest('[data-glo-apply-discount]')) { event.preventDefault(); event.stopImmediatePropagation(); enqueue(applyDiscount).catch(error => notify(error.message)); return; }
    const anchor = target.closest('[data-cart-sidebar],.header__icon--cart,.cart-icon-bubble,.list-item-cart');
    if (anchor && !anchor.hasAttribute('data-glo-view-cart') && !event.metaKey && !event.ctrlKey && !event.shiftKey && event.button === 0) {
      const url = new URL(anchor.getAttribute('href') || cartPath,location.origin);
      if (anchor.hasAttribute('data-cart-sidebar') || (url.origin === location.origin && url.pathname.replace(/\/$/,'') === cartPath.replace(/\/$/,''))) {
        event.preventDefault(); event.stopImmediatePropagation(); open(anchor); return;
      }
    }
    const button = target.closest('[data-btn-addtocart],[data-express-addtocart]');
    if (button && !button.matches('.is-notify-me,.is-soldout,[disabled]')) {
      const form = button.closest('form') || button.closest('.product-item,.col-options')?.querySelector('form');
      if (form?.querySelector('[name="id"]')) { event.preventDefault(); event.stopImmediatePropagation(); add(form,button); }
    }
  },true);
  document.addEventListener('submit',event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = new URL(form.action,location.origin).pathname;
    if (/\/cart\/add(?:\.js)?\/?$/.test(action)) {
      event.preventDefault(); event.stopImmediatePropagation();
      add(form,event.submitter || form.querySelector('[type="submit"]'));
    } else if (form.closest('glo-main-cart')) {
      if (state.passCheckout) { state.passCheckout = false; return; }
      event.preventDefault(); event.stopImmediatePropagation();
      const submitter = event.submitter;
      if (submitter?.name === 'checkout') {
        enqueue(async () => {
          await saveNote();
          const current = document.querySelector('glo-main-cart form');
          if (!current) return;
          const checkout = current.querySelector('[name="checkout"]');
          state.passCheckout = true;
          current.requestSubmit(checkout);
          state.passCheckout = false;
        }).catch(error => notify(error.message));
      } else enqueue(() => saveNote(true)).catch(error => notify(error.message));
    }
  },true);
  document.addEventListener('input',event => {
    if (event.target.id === 'GloCartNote') {
      state.noteDraft = event.target.value;
      const status = document.querySelector('[data-glo-note-status]'); if (status) status.textContent = '';
    }
  });
  document.addEventListener('change',event => {
    const input = event.target;
    if (input.matches('[data-glo-quantity]')) {
      if (!input.checkValidity()) { input.reportValidity(); return; }
      changeQuantity(input.closest('[data-glo-line-key]'),Number(input.value));
    }
    if (input.id === 'GloCartNote') enqueue(() => saveNote()).catch(error => notify(error.message));
    const form = input.closest('form');
    if (form && !input.matches('[data-glo-quantity]')) form.querySelector('[data-glo-added-state]')?.remove();
  });
  window.addEventListener('pageshow',event => { if (event.persisted) enqueue(async () => refresh(await getCart())).catch(error => notify(error.message)); });
  getCart().then(updateCounts).catch(() => {});
  window.GloCart = {open,close,refresh:() => enqueue(async () => refresh(await getCart()))};
})();

